import { Outlet } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Sidenav from '../Sidenav/Sidenav';

import { useSelector, useDispatch } from 'react-redux';

const DashboardLayout = (props) => {
  const ui = useSelector((state) => state.ui.ui);
  // console.log("ui", ui)

  return (
    <>
      <div className={`container-fluid`}>
        <div className='page'>
          <Header />
          <div className='row'>
            <div
              className={`side-nav-fixed col-md-${
                ui.toggleSideMenu ? '1' : '2'
              }`}
              style={{ width: ui.toggleSideMenu ? '80px' : '240px' }}
            >
              <Sidenav />
            </div>
            <div
              className='col-md-12 right-data-container'
              style={{
                paddingLeft: ui.toggleSideMenu ? '85px' : '240px',
                overflow: 'visible',
              }}
            >
              <Outlet />
            </div>
          </div>

          {/* <Footer /> */}
        </div>
      </div>
    </>
  );
};
export default DashboardLayout;
